import { typeRootState } from 'src/store';
import { useSelector } from 'react-redux';

export const useGetAlertModal = () => {
    const alertModal = useSelector((state: typeRootState) => state.alertModal);
    return alertModal;
}
